import {
  BulkUpdateEntitiesProgress,
  isProgressTerminal,
} from 'src/graphql/entities/custom-view/custom-view-bulk-update';

export type BulkUpdateOperationKind = 'update' | 'delete';

export function getBulkUpdateBannerTitle(input: {
  operationKind: BulkUpdateOperationKind;
  status?: string;
  isUndoInProgress: boolean;
}): string {
  const label = input.operationKind === 'delete' ? 'Bulk delete' : 'Bulk update';
  const normalizedStatus = input.status?.toLowerCase();

  if (normalizedStatus === 'undone') {
    return `${label} undone`;
  }
  if (input.isUndoInProgress) {
    return `${label} undo in progress`;
  }
  if (normalizedStatus === 'failed') {
    return `${label} failed`;
  }
  if (normalizedStatus === 'partial_failure') {
    return `${label} completed with issues`;
  }
  if (isProgressTerminal(normalizedStatus)) {
    return `${label} completed`;
  }

  return `${label} in progress`;
}

export function getBulkUpdateProgressDetails(input: {
  operationKind: BulkUpdateOperationKind;
  progress?: BulkUpdateEntitiesProgress;
  separator?: string;
  emptyStateText?: string;
}): string {
  const {
    progress,
    separator = ' • ',
    emptyStateText = 'Tracking operation status...',
  } = input;
  const verb = input.operationKind === 'delete' ? 'deleted' : 'updated';

  if (!progress) {
    return emptyStateText;
  }

  if (String(progress.status).toLowerCase() === 'undone') {
    const revertedCount = Math.max(0, progress.updatedCount);
    const conflictSuffix = progress.undoConflictCount
      ? `${separator}${progress.undoConflictCount} conflict(s) skipped`
      : '';

    return `${revertedCount} reverted${conflictSuffix}`;
  }

  if (!isProgressTerminal(progress.status)) {
    return `${progress.processed}/${progress.total} processed${separator}${progress.updatedCount} ${verb}${separator}${progress.failedCount} failed`;
  }

  return `${progress.updatedCount} ${verb}${separator}${progress.failedCount} failed`;
}
